<script>
	export let realty       = {Description:''};
	export let loading      = false;
</script>
{#if !loading}
<div class="selos">
	{#if realty.Video != null && realty.Video.trim().length > 0}
	<div class="selo selo-tour">
		<i class="fab fa-youtube"></i> Vídeo
	</div>
	{/if}
</div>
{/if}